// App.js
import React from 'react';
import Hero from './components/Hero';
import About from './components/About';
import Features from './components/Features';
import EventDetails from './components/EventDetails';
import Leadership from './components/Leadership';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <div className="App">
      <Hero />
      <About />
      <Features />
      <EventDetails />
      <Leadership />
      <Footer />
    </div>
  );
}

export default App;